<template>
	<!-- 1️⃣ fixed 外壳：只负责铺满视口 -->
	<div class="fixed-shell">
		<!-- 2️⃣ 内容坐标系：max-width + 居中 -->
		<div class="fixed-container">
			<!-- 3️⃣ 真正定位的元素 -->
			<div class="fixed-item" :style="itemStyle">
				<slot />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FixedShell',

	props: {
		top: [Number, String],
		right: [Number, String],
		bottom: [Number, String],
		left: [Number, String]
	},

	computed: {
		itemStyle() {
			const style = {
				position: 'absolute'
			};

			if (this.top != null) style.top = this.normalize(this.top);
			if (this.right != null) style.right = this.normalize(this.right);
			if (this.bottom != null) style.bottom = this.normalize(this.bottom);
			if (this.left != null) style.left = this.normalize(this.left);

			return style;
		}
	},

	methods: {
		normalize(val) {
			// 数字 → px
			if (typeof val === 'number') return `${val}px`;
			// 字符串原样返回（支持 %, env(), calc()）
			return val;
		}
	}
};
</script>

<style scoped lang="less">
@import '@rebuild/views/styles/container_base.less';

.fixed-shell {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 41;
	pointer-events: none;
}

.fixed-container {
	.center-750();

	height: 100%;
	position: relative;
	pointer-events: none;
}

.fixed-item {
	position: absolute;
	pointer-events: auto;
}
</style>
